import PaSelect from "components/field/PaSelect";
import PaTextField from "components/field/PaTextField";

interface Props {
  stepIndex: number;
}

export default function StripePaymentDefinition(props: Props) {
  const { stepIndex } = props;
  return (
    <>
      <PaTextField
        name={`steps.${stepIndex}.stepInformation.stripePaymentContent.amount`}
        label={"Suma (EUR)"}
        type="number"
      />
      <PaTextField
        name={`steps.${stepIndex}.stepInformation.stripePaymentContent.currency`}
        label={"Valiuta"}
        disabled
      />
      <PaTextField
        name={`steps.${stepIndex}.stepInformation.stripePaymentContent.description`}
        label={"Aprašymas"}
      />
      <PaSelect
        name={`steps.${stepIndex}.stepInformation.stripePaymentContent.paymentType`}
        label={"Mokėjimo tipas"}
        options={[
          { value: "ONE_TIME", label: "Vienkartinis" },
          { value: "SUBSCRIPTION", label: "Prenumerata" },
        ]}
      />
      <PaTextField
        name={`steps.${stepIndex}.stepInformation.stripePaymentContent.stripePriceId`}
        label={"Stripe Price ID (prenumeratoms)"}
      />
    </>
  );
}
